import { dynamicMenus } from "../apis";
import { ssoLink } from "../apis/cdn_service";
import { getExchangeLinks } from "../apis/nontransactional";
import { BUSINESS_LAYER_RESPONSE, HAMBURGER_MENU_ITEM_ID, NEWS_CMOT_MODE } from "../utils/global_variables";
import objBzDynamicMenu from '../BzDynamicMenu.json';
import banner1 from "../assets/images/banner1.svg";
import banner2 from "../assets/images/banner2.svg";
import { searchLocalStorage } from "../utils/global_functions";

async function _getSSOLink() {
    try {
        const resp = await ssoLink();
        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: resp.data };

    } catch (error) {
        return { status: false, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: error };
    }
}

// BT-115936 : Vinit Raut : 17-10-2023 : Breeze- Hamburger Menu- Exchange Links - Start
async function _getDynamicMenus(nCMOTMode) {

    let resp;
    try {
        //Prachi T [07-12-2023] - commented for 1st release to hide tabs from Dashboard
        resp = await dynamicMenus();

        // BT-109368 : Vinit Raut : 17-11-2023 : Breeze- Hamburger Menu- Exchange Links - Start
        // Prefill resp object from local file if dynamic API fails.
        if (!Boolean(resp)) {
            resp = { data: { ...objBzDynamicMenu } };
        }

        // Condtions to show login banner images from bundle or from cdn path ---start

        function validateURL(url) {
            const regex = '/https|www|\.com/';
            return regex.test(url);
        }

        if (!resp?.data?.loginBanner || typeof resp?.data?.loginBanner !== 'object' || !Array.isArray(resp?.data?.loginBanner?.items) || !resp?.data?.loginBanner?.items[0]?.displayImageUrl || validateURL(resp?.data?.loginBanner?.items[0]?.displayImageUrl !== true)) {
            resp.data.loginBanner = {
                "id": 4,
                "items": [
                    {
                        "id": 401,
                        "name": "login banner-1",
                        "displayImageUrl": banner1,
                        "onClickUrl": "",
                        "childs": "",
                        "isUrl": 1
                    },
                    {
                        "id": 402,
                        "name": "login banner-2",
                        "displayImageUrl": banner2,
                        "onClickUrl": "",
                        "childs": "",
                        "isUrl": 0
                    }
                ]
            };
        }


        // Condtions to show login banner images from bundle or from cdn path ---end

        // BT-109368 : Vinit Raut : 17-11-2023 : Breeze- Hamburger Menu- Exchange Links - End
        // Hari K:20-10-2023 BT-107439 dashboard-news-start
        if (nCMOTMode === NEWS_CMOT_MODE.CMOT_OFF) {
            const filterededDynamicMenu = resp?.data?.dashboardMenu?.items?.filter((each) => each.id !== HAMBURGER_MENU_ITEM_ID.NEWS && each.id !== HAMBURGER_MENU_ITEM_ID.EVENTS);
            resp = {
                ...resp, data: {
                    ...resp?.data, dashboardMenu: {
                        ...resp?.data?.dashboardMenu,
                        items: [...filterededDynamicMenu]
                    }
                }
            };
        } else {
        }

        // Hari K:20-10-2023 BT-107439 dashboard-news-end

        let ssoLink = resp?.data?.hamburgerMenu?.items?.find(it => it.id === 305);
        let ssoLinkData = null;

        if (ssoLink?.childs?.length > 0) {
            ssoLinkData = await ssoLink();
        }

        let exchangeLinksData;
        if (searchLocalStorage('USER_ACTIVE')) {
            exchangeLinksData = await getExchangeLinks();
        }

        // { /* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - Start */ }
        const exchangeLinksDataTransformed = exchangeLinksData.data.result.map((link, index) => {
            const { sLinkTitle, sLinkDescription, sLinkAddress, sLinkMode } = link;

            return {
                id: String(index + 1),
                iconurl: '',
                menuname: sLinkTitle,
                isExchangeLink: true,
                description: sLinkDescription,
                menuUrl: sLinkAddress,
                opentype: sLinkMode
            };
        });
        // { /* BT-121004 : Vinit Raut : 03-11-2023 Breeze- Hamburger Menu- Exchange Links bugfix - End */ }



        let ssoLinkIndex = resp?.data?.hamburgerMenu?.items.findIndex(it => it.id === 305);
        let linkIndex = resp?.data?.hamburgerMenu?.items.findIndex(it => it.id === 306);
        // BT-115936 : Maaz A : 17-10-2023 : Breeze- Hamburger Menu- Error Handling - Start        
        if (ssoLinkData && ssoLinkData?.data && ssoLinkIndex >= 0) {
            resp.data.hamburgerMenu.items[ssoLinkIndex].childs = [...ssoLinkData?.data];
        } else { }
        if (exchangeLinksDataTransformed && linkIndex >= 0) {
            resp.data.hamburgerMenu.items[linkIndex].childs = [...exchangeLinksDataTransformed];
        } else { }
        // BT-115936 : Maaz A : 17-10-2023 : Breeze- Hamburger Menu- Error Handling - End

        return { status: true, message: BUSINESS_LAYER_RESPONSE.SUCCESS, data: resp.data };
    } catch (error) {
        return { status: true, message: BUSINESS_LAYER_RESPONSE.FAILURE, data: resp.data };
    }
}
// BT-115936 : Vinit Raut : 17-10-2023 : Breeze- Hamburger Menu- Exchange Links - End

export {
    _getDynamicMenus,
    _getSSOLink
};